import { useEffect, useState } from "react";
import { SourceListItem } from "../../interfaces/SourceListItemObj";
import { listAllDocumentCoObjects, listDocumentCoObjects } from "../../../api/object/CoObjectGeneral";
import { DocumentPartTreeSelection } from "../DocumentPartTree";
import { DocumentPart } from "../../../api/models";
import { descriptionLanguage } from "../../../utils/helpers/LanguageHelper";

interface SourceListPageHookProps {
  documentPartTreeSelection: DocumentPartTreeSelection;
  documentPart: DocumentPart;
}

export const useSourceListPage = (props: SourceListPageHookProps) => {
  const [documentSourceList, setDocumentSourceList] = useState<SourceListItem[]>([]);

  useEffect(() => {
    const language = descriptionLanguage();
    if (!props.documentPartTreeSelection) {
      listAllDocumentCoObjects(props.documentPart.id, language)
        .then((result) => addDbInDescriptionIfNeeded(result))
        .then((result) => setDocumentSourceList(result));
    } else {
      const documentId =
        props.documentPartTreeSelection.data?.data?.id ?? props.documentPartTreeSelection.data?.data?.documentPart?.id;
      listDocumentCoObjects(documentId, language)
        .then((result) => addDbInDescriptionIfNeeded(result))
        .then((result) => setDocumentSourceList(result));
    }
  }, []);

  const addDbInDescriptionIfNeeded = (sourceListItems: SourceListItem[]) => {
    const sourceListItemsWithMoreDbIds: SourceListItem[] = [];
    const firstElementFromDb = sourceListItems.find((item) => item.dbId && item.dbId !== "");
    let thereIsJustOneDb = true;
    thereIsJustOneDb = addDbInSourceItemDesc(
      sourceListItems,
      firstElementFromDb,
      thereIsJustOneDb,
      sourceListItemsWithMoreDbIds
    );
    if (thereIsJustOneDb) return sourceListItems;
    else return sourceListItemsWithMoreDbIds;
  };

  function addDbInSourceItemDesc(
    sourceListItems: SourceListItem[],
    firstElementFromDb: SourceListItem,
    thereIsJustOneDb: boolean,
    sourceListItemsWithMoreDbIds: SourceListItem[]
  ) {
    for (const item of sourceListItems) {
      if (
        isNotNullOrEmpty(item.dbId) &&
        firstElementFromDb &&
        isNotNullOrEmpty(firstElementFromDb.dbId) &&
        firstElementFromDb.dbId !== item.dbId
      )
        thereIsJustOneDb = false;
      sourceListItemsWithMoreDbIds.push({
        ...item,
        desc: formatDesc(item.dbId, item.desc, item.cod, item.descDb),
      });
    }
    return thereIsJustOneDb;
  }

  const isNotNullOrEmpty = (element: string) => {
    return element && element !== "";
  };

  const formatDesc = (dbId: string, desc: string, idForm: string, descDb: string) => {
    if (!descDb || descDb === "") descDb = dbId;
    if (!desc || desc === "") desc = idForm;
    if (dbId && descDb) return `${descDb} - ${desc}`;
    return desc;
  };

  return { documentSourceList };
};
